import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Creator from "./Creator";
import { store } from "./app/Store";
import TrainingEditor from "./features/TrainingEditor/TrainingEditor";
import Dashboard from "./features/dashboard/Dashboard";
import DashboardPage from "./features/dashboard/DashboardPage";
import "./features/i18n/i18n";
import NewTrainingPage from "./features/new_training/NewTrainingPage";
import "./index.css";
import 'leaflet/dist/leaflet.css';
import { AuthenticationProvider } from "@playit/shared-authentication";
import { ReactFlowProvider } from "@xyflow/react";
import ThemeInitializer from "./components/ThemeInitializer";
import ScreenScaleInitializer from "./components/ScreenScaleInitializer";
import { applyScreenScale } from "./helpers/screenScale";
import PiThemeProvider from "./components/PiThemeProvider";
import { installAuthRefreshInterceptor } from "./services/AuthRefreshInterceptor";

installAuthRefreshInterceptor(store);

// Apply dark mode class synchronously before React renders to prevent flash
const storedTheme = localStorage.getItem("themeMode");
if (storedTheme === "dark") {
  document.body.classList.add("dark");
} else {
  document.body.classList.remove("dark");
}

// Apply screen scaling before the first render so the layout doesn't jump
applyScreenScale();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
  <AuthenticationProvider>
    <PiThemeProvider>
      <ThemeInitializer />
      <ScreenScaleInitializer />
        <ReactFlowProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Creator />}>
              <Route path="/" element={<Dashboard />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="newTraining" element={<NewTrainingPage />} />
                <Route path="importTraining" element={<div>import training placeholder</div>} />
              </Route>
              <Route path="/TrainingEditor/:trainingId" element={<TrainingEditor />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </ReactFlowProvider>
    </PiThemeProvider>
    </AuthenticationProvider>
  </Provider>
);
